export default "__VITE_ASSET__CqQAxNln__"